export enum PatientStatusEnum {
    aguardando = 1,
    evadido = 2,
    atendido = 4,
    chamando = 5,
    emAtendimento = 6
}